/**
 * Use Case: Fetch Menus
 * Business logic for fetching menu items
 */

import type { MenuItem } from "../model/MenuModel";
import type { IMenuRepository } from "../repository/IMenuRepository";
import { menuContainer, TYPES } from "../../di/MenuModule";

/**
 * Fetch all menu items for the current user.
 * Results are sorted by sortOrder.
 */
export const FetchMenusUseCase = async (): Promise<readonly MenuItem[]> => {
  const repository = menuContainer.get<IMenuRepository>(TYPES.IMenuRepository);
  const menus = await repository.fetchMenus();

  // Sort by sortOrder
  return [...menus].sort((a, b) => a.sortOrder - b.sortOrder);
};

